import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { AppDataService } from 'src/app/services/data/app-data.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { firstValueFrom } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService  {

  constructor(
    private authService: AuthService,
    private router: Router,
    private appDataService: AppDataService
  ) {
  }

  async canActivate(): Promise<boolean> {
    const isLogged = await firstValueFrom(this.authService.isLoggedObservable.pipe(take(1)));

    if (!isLogged) {
      void this.router.navigate(['/login']);
      return false;
    }

    return true;
  }

}
